import {
    truthyPropComparator,
    strategySwitchComparator,
    structuredComparator,
    compareWithCastIntegerIfPossible,
    selectorComparator,
    selectorPropComparator,
} from '@mews/framework';
import { Resource, ResourceDataDiscriminator } from '@mews-commander/resources';

export const MODULE_NAME = 'entities';

export const CODE_ENGLISH_US = 'en-US';

export const MAX_SPACE_AGE = 10 * 60 * 1000;

export const RESOURCE_EXTENT = {
    ResourceCategoryAssignments: true,
    ResourceCategories: true,
    Resources: true,
    Slots: true,
};

const returnNonNullable =
    <T>(compare: (x: T, y: T) => -1 | 0 | 1) =>
    (x: T | null | undefined, y: T | null | undefined) => {
        if (!!x && !!y) return compare(x, y);

        if (!x && !y) return 0;

        return y ? -1 : 1;
    };
// By modyfing this please ensure the type is consistent with transformSpace, mainly with overbooking slots
const spaceResourceComparator = structuredComparator<Resource>([
    truthyPropComparator((resource) => resource.resourceCategoryId),
    // @ts-expect-error $TSFixMeError: Argument of type 'string' is not assignable to parameter of type 'never'.
    selectorPropComparator((resource) => resource.resourceCategoryOrdering),
    selectorPropComparator((resource) => resource.resourceCategoryId),
    // @ts-expect-error $TSFixMeError: Argument of type 'string' is not assignable to parameter of type 'never'.
    truthyPropComparator((resource) => resource.isSlot),
    selectorComparator(
        (resource): string | undefined => resource.data?.value?.floorNumber,
        returnNonNullable(compareWithCastIntegerIfPossible)
    ),
]);

const discriminatorStrategyMap = {
    [ResourceDataDiscriminator.Space]: spaceResourceComparator,
};

export const resourceComparator = structuredComparator<Resource>([
    selectorComparator((resource) => resource.data.discriminator),
    strategySwitchComparator((resource: Resource) => resource.data.discriminator, discriminatorStrategyMap),
    selectorComparator((resource) => resource.name, compareWithCastIntegerIfPossible),
]);

export const META_STATE_STARTED = {
    meta: {
        hasFailed: false,
        isFetching: true,
    },
};

export const META_STATE_SUCCEEDED = {
    meta: {
        hasFailed: false,
        isFetching: false,
    },
};

export const META_STATE_FAILED = {
    meta: {
        hasFailed: true,
        isFetching: false,
    },
};

export const EMPTY_CATEGORY = { id: null, name: '', shortName: '', type: '' };
export const EMPTY_RESOURCE_CATEGORY_ASSIGNMENT = { categoryId: null };

export const DEFAULT_PREAUTHORIZATION_EXPIRATION_DAYS = 7;
